// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"910d17bb","114":"1384b90f","191":"7ec2b1c6","200":"f8a77b8e","264":"5854b917","276":"eadb0881","369":"f5f2cc6d","548":"b3cf8f1e","568":"319f64a4","669":"bbbc5c63","841":"76758372"}[chunkId] + ".chunk.js";
};